import React, { useState } from "react";

//*files
import cssClasses from "./SelectPreferredLocation.module.css";
import Close from "../../Components/Icons/Close";

//subComponent
import DropDown from "../../Subcomponents/DropDown";
import Button from "../../Subcomponents/Button";

//*MUI
import { Box, Modal } from "@mui/material";

function SelectPreferredLocation({
  open,
  handleClose,
  locationList,
  returnRes,
  title = "Select Preferred Location",
  label = "Preferred Location",
  placeHolder = "Select Location",
}) {
  const [selectedLocation, setSelectedLocation] = useState("");
  const [helperText, setHelperText] = useState("");

  function closeModal() {
    handleClose();
  }

  function submit() {
    if (!selectedLocation) {
      setHelperText(`Please select a ${label.toLowerCase()}`);
      return;
    }
    returnRes(selectedLocation);
    closeModal();
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span
            style={{ position: "absolute", top: "0rem", right: "1rem", cursor: "pointer" }}
            onClick={closeModal}
            tabIndex={0}
          >
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>{title}</div>
        </div>
        <Box margin={"2rem"}>
          <div className={cssClasses.wrapperContent}>
            <div className={cssClasses.wrapperBlock}>
              <div className={cssClasses.blockLabel}>
                {label} <span style={{ color: "red" }}> *</span>
              </div>
              <div className={cssClasses.wrapperdropDown}>
                <DropDown
                  list={locationList.map((loc) => ({
                    label: loc,
                    value: loc,
                  }))}
                  selectedValue={selectedLocation}
                  onChangeSelect={(value) => {
                    setSelectedLocation(value);
                    setHelperText("");
                  }}
                  placeHolder={placeHolder}
                  style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                  helperText={helperText}
                />
              </div>
            </div>
          </div>
        </Box>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={closeModal}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Save"}
              clicked={submit}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default SelectPreferredLocation;
